<template>
  <div class="about">
    <h1>暂无信息</h1>
  </div>
</template>
